var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 16C20.3576 16 13.427 20.2086 8.31298 27.0446C7.89567 27.6047 7.89567 28.3871 8.31298 28.9472C13.427 35.7914 20.3576 40 28 40C35.6424 40 42.573 35.7914 47.687 28.9554C48.1043 28.3953 48.1043 27.6129 47.687 27.0528C42.573 20.2086 35.6424 16 28 16ZM28.5482 36.4502C23.4751 36.7714 19.2857 32.5628 19.6048 27.4482C19.8666 23.2313 23.2624 19.8133 27.4518 19.5498C32.5249 19.2286 36.7143 23.4372 36.3952 28.5518C36.1252 32.7605 32.7295 36.1784 28.5482 36.4502ZM28.2946 32.5463C25.5616 32.7193 23.3033 30.4544 23.4833 27.7035C23.6224 25.4303 25.4553 23.5937 27.7136 23.4454C30.4466 23.2725 32.7049 25.5374 32.5249 28.2883C32.3776 30.5697 30.5447 32.4063 28.2946 32.5463Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 53,
    height: 53,
    rx: 8.5,
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2b2d8bc67f0e658e7525dbff8621993f.svg";
export { ForwardRef as ReactComponent };